import { lazy } from "react";
import { ElementDetails } from "@/lib/types";
import { GoogleEmailsProps } from "./types";

export const details = {
  name: "GoogleEmails",
  description: "Displays a list of your Google Emails",
  tags: ["Productivity", "Organization", "Communication", "Business"],
  category: "Google",
  grid: {
    "extra-small": [1, 1],
    "small": [2, 1],
    "medium": [3, 3],
    "large": [4, 4],
  },
  gridNames: {
    "extra-small": "Extra Small",
    "small": "Small",
    "medium": "Medium",
    "large": "Large",
  },
  app: lazy(() => import("./App").then(m => ({ default: m.App }))),
  integrationsUsed: ["google"],
  integrationScopes: { google: ["gmail"] },
  defaultProps: {},
} as ElementDetails<GoogleEmailsProps>;
